import _ from 'lodash';
import LocalDataService from './LocalDataService';
//import { FirebaseDataService } from '../services/FirebaseDataServices';
import dayjs from 'dayjs';
var isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);

const LocalJSONDataServices = new LocalDataService();

export const DataServices = {
  async getBoardAndRestructure() {
    let data = await LocalJSONDataServices.getboard();
    var DataCopy = _.cloneDeep(data);
    //var map = [];
    //map = _.map(DataCopy, 'label');
    //console.log(map);
    return DataCopy;
  },
  async SaveDataTofirebase() {
    //let receivedData = await FirebaseDataService.getOnce();
    //console.log('receivedData: ', receivedData);
  },
  async scheduleStructure_day(data) {
    var boardgroup;
    var RestructureData = [];
    let board = await LocalJSONDataServices.getboard();
    var DataCopy = _.cloneDeep(data);
    let rowIndex = 0;
    let rowAdded = 0;
    for (let i = 0; i < board.length; i++) {
      boardgroup = _.remove(DataCopy, function (n) {
        return n.board == board[i].label;
      });
      if (boardgroup.length) {
        for (let g = 0; g < boardgroup.length; g++) {
          if (boardgroup[g].enddate == undefined) {
            if (
              boardgroup[g].strdate == dayjs().format('YYYY-MM-DD')
            ) {
              RestructureData[rowAdded] = {
                no: g + 1,
                board: boardgroup[g].board,
                fullname: '',
                desLength: board.length,
                rowIndex: rowIndex,
                time: this.endCheck('time', [
                  boardgroup[g].strtime,
                  boardgroup[g].endtime,
                ]),
                description: boardgroup[g].description,
              };
              rowAdded = rowAdded + 1;
              rowIndex = rowIndex + board.length;
            } else {
              //
            }
          } else if (
            dayjs().isBetween(
              boardgroup[g].strdate,
              dayjs(boardgroup[g].enddate),
            ) == true
          ) {
            RestructureData[rowAdded] = {
              no: g + 1,
              board: boardgroup[g].board,
              fullname: '',
              desLength: board.length,
              rowIndex: rowIndex,
              time: this.endCheck('time', [
                boardgroup[g].strtime,
                boardgroup[g].endtime,
              ]),
              description: boardgroup[g].description,
            };
            rowAdded = rowAdded + 1;
            rowIndex = rowIndex + board.length;
          } else {
            //
          }
        }
      } else {
        RestructureData[rowAdded] = {
          no: i + 1,
          board: board[i].label,
          fullname: '',
          desLength: 1,
          rowIndex: rowIndex,
          time: '',
          description: [`-`],
        };
        rowAdded = rowAdded + 1;
        rowIndex = rowIndex + 1;
      }
    }
    return RestructureData;
  },
  async scheduleStructure_day_back2(data) {
    var boardgroup;
    var RestructureData = [];
    let board = await LocalJSONDataServices.getboard();
    var DataCopy = _.cloneDeep(data);
    let rowIndex = 0;
    let rowAdded = 0;
    let RealBoardLength = 1;
    for (let i = 0; i < board.length; i++) {
      boardgroup = _.remove(DataCopy, function (n) {
        return n.board == board[i].label;
      });
      if (boardgroup.length) {
        for (let g = 0; g < boardgroup.length; g++) {
          if (boardgroup[g].enddate == undefined) {
            if (
              boardgroup[g].strdate == dayjs().format('YYYY-MM-DD')
            ) {
              RestructureData[rowAdded] = {
                no: g + 1,
                board: boardgroup[g].board,
                fullname: '',
                desLength: RealBoardLength,
                rowIndex: rowIndex,
                time: this.endCheck('time', [
                  boardgroup[g].strtime,
                  boardgroup[g].endtime,
                ]),
                description: boardgroup[g].description,
              };
              rowAdded = rowAdded + 1;
              rowIndex = rowIndex + RealBoardLength;
              RealBoardLength = RealBoardLength + 1;
            } else {
              //
            }
          } else if (
            dayjs().isBetween(
              boardgroup[g].strdate,
              dayjs(boardgroup[g].enddate),
            ) == true
          ) {
            RestructureData[rowAdded] = {
              no: g + 1,
              board: boardgroup[g].board,
              fullname: '',
              desLength: RealBoardLength,
              rowIndex: rowIndex,
              time: this.endCheck('time', [
                boardgroup[g].strtime,
                boardgroup[g].endtime,
              ]),
              description: boardgroup[g].description,
            };
            rowAdded = rowAdded + 1;
            rowIndex = rowIndex + RealBoardLength;
            RealBoardLength = RealBoardLength + 1;
          } else {
            //
          }
          RealBoardLength = 1;
        }
      } else {
        RestructureData[rowAdded] = {
          no: i + 1,
          board: board[i].label,
          fullname: '',
          desLength: 1,
          rowIndex: rowIndex,
          time: '',
          description: [`-`],
        };
        rowAdded = rowAdded + 1;
        rowIndex = rowIndex + 1;
      }
      //console.log('R : ', RestructureData);
    }
    //console.log('RestructureData : ', RestructureData);
    return RestructureData;
  },
  endCheck(type, data) {
    //console.log(data);
    switch (type) {
      case 'time':
        if (data[1] != undefined) {
          return data[0];
        } else {
          return data[0];
        }
      case 'day':
        break;
    }
  },
  async scheduleStructure_day_back(data) {
    var boardgroup;
    var RestructureData = [];
    let board = await LocalJSONDataServices.getboard();
    var DataCopy2 = _.cloneDeep(data);
    var RestructureData_atr = [];
    var rowCount = 0;
    let rowIndex = 0;
    let rowAdded = 0;
    var DataCopy = _.sortBy(DataCopy2, [
      function (o) {
        return o.strtime;
      },
    ]);
    for (let h = 0; h < DataCopy.length; h++) {
      if (DataCopy[h].enddate == undefined) {
        if (DataCopy[h].strdate == dayjs().format('YYYY-MM-DD')) {
          RestructureData_atr[rowCount] = DataCopy[h];
          rowCount++;
        } else {
          //
        }
      } else if (
        dayjs().isBetween(
          DataCopy[h].strdate,
          DataCopy[h].enddate,
          'day',
          '[]',
        ) == true
      ) {
        //console.log('xt');
        RestructureData_atr[rowCount] = DataCopy[h];
        rowCount++;
      } else {
        //
      }
    }
    for (let i = 0; i < board.length; i++) {
      boardgroup = _.remove(RestructureData_atr, function (n) {
        return n.board == board[i].label;
      });
      if (boardgroup.length) {
        for (let i = 0; i < boardgroup.length; i++) {
          RestructureData[rowAdded] = {
            no: i + 1,
            key: boardgroup[i].key,
            board: boardgroup[i].board,
            fullname: '',
            desLength: boardgroup.length,
            rowIndex: rowIndex,
            time: this.endCheck('time', [
              boardgroup[i].strtime,
              boardgroup[i].endtime,
            ]),
            description: boardgroup[i].description,
          };
          rowAdded = rowAdded + 1;
          rowIndex = rowIndex + 1;
        }
      } else {
        RestructureData[rowAdded] = {
          no: i + 1,
          key: '',
          board: board[i].label,
          fullname: '',
          desLength: 1,
          rowIndex: rowIndex,
          time: '',
          description: [`-`],
        };
        rowAdded = rowAdded + 1;
        rowIndex = rowIndex + 1;
      }
    }
    //console.log(RestructureData);
    return RestructureData;
  },
  async scheduleStructure_day_back_spa(data, spaDate) {
    var boardgroup;
    var RestructureData = [];
    let board = await LocalJSONDataServices.getboard();
    var DataCopy2 = _.cloneDeep(data);
    var RestructureData_atr = [];
    var rowCount = 0;
    let rowIndex = 0;
    let rowAdded = 0;
    var DataCopy = _.sortBy(DataCopy2, [
      function (o) {
        return o.strtime;
      },
    ]);
    for (let h = 0; h < DataCopy.length; h++) {
      if (DataCopy[h].enddate == undefined) {
        if (
          DataCopy[h].strdate == dayjs(spaDate).format('YYYY-MM-DD')
        ) {
          RestructureData_atr[rowCount] = DataCopy[h];
          rowCount++;
        } else {
          //
        }
      } else if (
        dayjs(spaDate).isBetween(
          DataCopy[h].strdate,
          DataCopy[h].enddate,
          'day',
          '[]',
        ) == true
      ) {
        //console.log('xt');
        RestructureData_atr[rowCount] = DataCopy[h];
        rowCount++;
      } else {
        //
      }
    }
    for (let i = 0; i < board.length; i++) {
      boardgroup = _.remove(RestructureData_atr, function (n) {
        return n.board == board[i].label;
      });
      if (boardgroup.length) {
        for (let i = 0; i < boardgroup.length; i++) {
          RestructureData[rowAdded] = {
            no: i + 1,
            key: boardgroup[i].key,
            board: boardgroup[i].board,
            fullname: '',
            desLength: boardgroup.length,
            rowIndex: rowIndex,
            time: this.endCheck('time', [
              boardgroup[i].strtime,
              boardgroup[i].endtime,
            ]),
            description: boardgroup[i].description,
          };
          rowAdded = rowAdded + 1;
          rowIndex = rowIndex + 1;
        }
      } else {
        RestructureData[rowAdded] = {
          no: i + 1,
          key: '',
          board: board[i].label,
          fullname: '',
          desLength: 1,
          rowIndex: rowIndex,
          time: '',
          description: [`-`],
        };
        rowAdded = rowAdded + 1;
        rowIndex = rowIndex + 1;
      }
    }
    //console.log(RestructureData);
    return RestructureData;
  },
  async scheduleStructure_month_back(data) {
    /*var DataCopy = _.cloneDeep(data);
    let board = await LocalJSONDataServices.getboard();
    var DataCopy2 = _.sortBy(DataCopy, [
      function (o) {
        return o.strtime;
      },
    ]);*/
    return data;
  },
  async scheduleStructure_day_Slide(data) {
    // eslint-disable-next-line no-unused-vars
    let boardgroup;
    let RestructureDataTemp = [];
    let RestructureData;
    let board = await LocalJSONDataServices.getboard();
    var DataCopy2 = _.cloneDeep(data);
    for (let i = 0; i < board.length; i++) {
      boardgroup = _.remove(DataCopy2, function (n) {
        return n.board == board[i].label;
      });
      RestructureDataTemp[i] = {
        board: board[i].label,
        data: boardgroup,
        blank: boardgroup[0].description == '-' ? true : false,
      };
    }

    RestructureData = _.remove(RestructureDataTemp, function (n) {
      return n.blank == false;
    });
    //console.log('RestructureData :', RestructureData);
    return RestructureData;
  },
  async scheduleStructure_day_Slide_optional(data) {
    var DataCopy2 = _.cloneDeep(data);
    // eslint-disable-next-line no-unused-vars
    let RestructureData;
    RestructureData = _.remove(DataCopy2, function (n) {
      return n.key != '';
    });
    return RestructureData;
  },
  ConvertDateToThai(type, fdate) {
    //console.log('ConvertDateToThai : ', fdate);
    var vdate = '';
    var sdate = '';
    var monthNames = [
      'startrecord',
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฏาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม',
    ];
    switch (type) {
      case 'now':
        vdate = dayjs().add(543, 'years').format('DD/MM/YYYY');
        sdate = `${vdate.substring(0, 2)} ${
          monthNames[parseInt(vdate.substring(3, 5))]
        } ${vdate.substring(6, 10)}`;
        return sdate;
      case 'fix':
        vdate = dayjs(fdate).add(543, 'years').format('DD/MM/YYYY');
        sdate = `${vdate.substring(0, 2)} ${
          monthNames[parseInt(vdate.substring(3, 5))]
        } ${vdate.substring(6, 10)}`;
        return sdate;
      case 'now_year':
        vdate = dayjs().add(543, 'years').format('YYYY');
        return vdate;
    }
  },
};
